import * as React from "react";
import { motion } from "motion/react";
import Item from "./Item.js";
/* empty css          */
const menuContainer = {
  visible: {
    x: "0%",
    transition: {
      ease: "easeIn",
      duration: 0.3
    }
  },
  hidden: {
    x: "-100%",
    transition: {
      ease: "easeOut",
      duration: 0.3
    }
  }
};
const Menu = ({
  active,
  children,
  menuItems,
  onItemClick,
  firstMenuRef,
  isOpen
}) => /* @__PURE__ */ React.createElement(
  motion.div,
  {
    className: "site-nav-mobile__page",
    animate: active ? "visible" : "hidden",
    variants: menuContainer,
    "aria-hidden": !active
  },
  children,
  /* @__PURE__ */ React.createElement("ul", { className: "site-nav-mobile__menu" }, menuItems.map((item, index) => /* @__PURE__ */ React.createElement(
    Item,
    {
      key: item.label,
      onItemClick,
      tabIndex: isOpen && active ? void 0 : -1,
      linkRef: index === 0 ? firstMenuRef : void 0,
      ...item
    }
  )))
);
export {
  Menu as default
};
//# sourceMappingURL=Menu.js.map
